import * as React from "react"
import { AnchorButton, Theme } from "gatsby-interface"
import { MdArrowForward } from "react-icons/md"
import { Integration } from "@modules/ui/components/Integration"

const cmsIntegrationRowCss = (theme: Theme) => ({
  borderTop: `1px solid ${theme.colors.grey[20]}`,
})

type CmsManualIntegrationRowProps = {
  name: string
  logoUrl: string
  docUrl?: string
}

export function CmsManualIntegrationRow({
  name,
  logoUrl,
  docUrl = "/docs/integrations",
}: CmsManualIntegrationRowProps) {
  return (
    <Integration css={cmsIntegrationRowCss} key={name}>
      <Integration.Row>
        <Integration.Vendor image={logoUrl} name={name} />

        <Integration.Actions>
          <AnchorButton
            variant={`GHOST`}
            href={docUrl}
            target="_blank"
            rightIcon={<MdArrowForward />}
            aria-label={`Setup instructions for ${name}`}
          >
            Setup instructions
          </AnchorButton>
        </Integration.Actions>
      </Integration.Row>
    </Integration>
  )
}
